import { TicketIcon } from "@heroicons/react/24/outline";
import TicketPress from "./TicketPress";
import TicketFlag from "./ticketFlag";
import TicketPrint from "./ticketPrint";
import TicketDisbursment from "./TicketDisbursment";
import TicketAssignment from "./TicketAssignment";
import TicketReport from "./TicketReport";

const Ticket = [
    {
        path: "ticket",
        exact: true,
        showChildren: true,
        sidebarMenu: true,
        displayName: "Ticket",
        icon: TicketIcon,
        children: [
            ...TicketPress,
            ...TicketFlag,
            ...TicketPrint,
            ...TicketDisbursment,
            ...TicketAssignment,
            ...TicketReport,
        ],
    },
];

export default Ticket;
